import { BentResponse } from 'bent';
import { httpClient } from '../../../httpClient';

const url = process.env.REACT_APP_CHECK_IN_SERVICE_URL!;

export const getSurveyFormListing = (token: string) =>
  httpClient('GET', url!, 200, { Authorization: `Bearer ${token}` })(`/first-assessments`) as Promise<BentResponse>;
